import React from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Navigate, Route, Routes } from "react-router-dom";

import Navbar from "./Components/Features/Navbar";
import CategorySection from "./Components/Features/CategorySection";
import BannerSection from "./Components/Features/BannerSection";
import AllRestaurants from "./Components/Features/AllRestaurantSection";
import BuiltForFood from "./Components/Features/Builtfor food";
import DownloadApp from "./Components/Features/DownloadApp";
import Footer from "./Components/Features/Footer";
import FAQSection from "./Components/Features/FAQSection";
import RestaurantNear from "./Components/Features/RestaurantNear";

import Login from "./Components/Features/Login";
import ProfileDetails from "./Components/Features/ProfileDetails";
import Checkout from "./Components/Features/Checkout";
import RestaurantHeroDetails from "./Components/Features/RestaurantHeroDetails";
import AccountLayout from "./Components/Features/Account/AccountLayout";
import Dashboard from "./Components/Features/Account/Dashboard";
import Orders from "./Components/Features/Account/Orders";
import SavedAddress from "./Components/Features/Account/SavedAddress";
import Favourite from "./Components/Features/Account/Favourite";
import PaymentMode from "./Components/Features/Account/PaymentMode";
import HelpSupport from "./Components/Features/Account/HelpSupport";
import Settings from "./Components/Features/Account/Settings";

import ProtectedRoute from "./Components/Utils/ProtectedRoute";
import PublicRoute from "./Components/Utils/PublicRoute";
import Profile from "./Components/Features/Account/Profile";
import LogoutWatcher from "./Components/Utils/LogoutWatcher";
import AboutPage from "./Components/Features/About";
import OrderSummary from "./Components/Features/Account/Receipt";
import TopOffers from "./Components/Features/TopOffers";
import OfferItems from "./Components/Features/OfferItems";
import SearchResults from "./Components/Features/SearchResults";

const HomePage = () => {
  return (
    <>
      <Navbar />
      <RestaurantNear />
      <BannerSection />
      <CategorySection />
      <AllRestaurants />
      <BuiltForFood />
      <DownloadApp />
      <FAQSection />
      <Footer />
    </>
  );
};

function App() {
  return (
    <>
      <LogoutWatcher />

      <Routes>
        {/* =========================
          PUBLIC ROUTES
      ========================== */}

        <Route path="/" element={<HomePage />} />

        <Route path="/about" element={<AboutPage />} />

        <Route
          path="/restaurant-details/:userid"
          element={<RestaurantHeroDetails />}
        />

        <Route path="/offer-items/:value" element={<OfferItems />} />
        <Route
          path="/search"
          element={
            <>
              <Navbar />
              <SearchResults />
            </>
          }
        />

        {/* Login page sirf logged-out user ke liye */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route path="/profile-details" element={<ProfileDetails />} />

          <Route path="/checkout" element={<Checkout />} />

          <Route path="/top-offers" element={<TopOffers />} />

          {/* Account nested routes */}
          <Route path="/account" element={<AccountLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="orders" element={<Orders />} />
            <Route path="address" element={<SavedAddress />} />
            <Route path="favourite" element={<Favourite />} />
            <Route path="payment" element={<PaymentMode />} />
            <Route path="help" element={<HelpSupport />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          <Route path="/order-summary" element={<OrderSummary />} />
        </Route>

        {/* Unknown route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
